export default __webpack_public_path__ + "static/media/Icon-4.f1b3fb6d.svg";